// count the average of a given number array
export const average = (array: number[]) => {
  const sum = array.reduce((acc, value) => {
    return acc + value
  }, 0)

  return sum / array.length
}
